import { IncorrectTypeError } from './incorrect-type-error';

export function assertIsArray<T>(data: unknown): asserts data is Array<T> {
  if (!Array.isArray(data)) {
    throw new IncorrectTypeError(`Array required, received ${JSON.stringify(data)}`);
  }
}
